import { Link } from "react-router-dom";

const NextHomeSection = () => {
  return (
    <section className="relative py-[58px] px-4 sm:px-10 lg:px-[175px] mt-[30px]">
      <img
        src="/assets/images/explore-bg.png"
        className="img-background"
        alt=""
      />
      <div className="lg:flex gap-x-[81px] items-center text-textWhite">
        <div className="flex-1">
          <h2 className="text-[36px] font-semibold">
            Your Next Home in Nigeria Awaits You, No Matter Where You Are
          </h2>
          <p className="mt-5 text-justify sm:text-left text-[16px]">
            Discover top properties and investment opportunities across Nigeria,
            tailored just for you. Whether you’re looking to buy, or invest,
            we've made it easy for you to find the perfect place - all from the
            comfort of your current location.
          </p>
        </div>
        <Link to="/property-search" className="mt-8 lg:mt-0 block">
          <button className="bg-white hover:bg-primary duration-300 mt-8 sm:mt-0 text-primary hover:text-textWhite px-[35px] py-3 text-[18px] uppercase font-semibold rounded-[10px]">
            Explore
          </button>
        </Link>
      </div>
    </section>
  );
};

export default NextHomeSection;
